import http, { AUTH_ROUTES } from '../../../../services/api';

//SECURITY GUEST VALIDATION
export const guestValidation = async (payload, setLoading, setConfirmationMsg, setSuccess) => {
  try {
    await http.post(AUTH_ROUTES.MANAGER_GUEST_VALIDATION, payload);
    setLoading(false);

    setSuccess(true);
  } catch (e) {
    setConfirmationMsg(e.response?.data?.result?.message);
  } finally {
    setLoading(false);
  }
};

//GET GUEST CODE HANDLER
export const getGuestCode = async (setLoading, userId, guestCode, setInvitedGuest, setConfirm) => {
  setLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_MANAGER_GUEST_CODE(userId, guestCode));
console.log(data, "show")
    setInvitedGuest(data);
    setConfirm(true);
  } catch (e) {
    setLoading(false);
  } finally {
    setLoading(false);
  }
};

export const getEstateName = async (setEstateName, userId) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));
    setEstateName(data?.estateName);
  } catch (e) {}
};
